/**
 * A full reaction equation — CaCO₃ + 2 HCl → CaCl₂ + H₂O + CO₂ — set as text.
 *
 * It was KaTeX (`\ce{}`) before, split term by term because KaTeX hard-codes
 * `white-space: nowrap` on `.katex .base` and a single call for the whole
 * equation ran off the edge of the reaction card with no way to wrap. The
 * split fixed the wrapping but not the harder problem: the card sits inside an
 * SVG `<foreignObject>`, and there the formulas were coming out blank while
 * the " + " and " → " between them still showed. See chemFormat.ts for why
 * characters are the safer material here — they also wrap by themselves,
 * which is what the per-term split was for.
 */
import { formatChemistry } from '../chemFormat';

export function ChemEquation({ equation }: { equation: string | undefined }): React.JSX.Element | null {
  if (!equation) return null;
  return <span className="chemlab-equation">{formatChemistry(equation)}</span>;
}
